<template lang="html">
	<div class="inner-modal">
		<div class="head-modal">
			<div class="head-modal-title">
				Editer le mot de passe
			</div>
			<div class="head-modal-emphase">
				Modifier votre mot de passe pour plus de sécurité
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui default-form-ui">
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('mot de passe actuel')}">
						<label for="password">mot de passe actuel</label>
						<input type="password" v-validate="'required'" name="mot de passe actuel" v-model="password">
					</div>
					<div v-if="errors.has('mot de passe actuel')" class="error-message">{{ errors.first('mot de passe actuel') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('nouveau mot de passe')}">
						<label for="newPassword1">nouveau mot de passe</label>
						<input type="password" v-validate="'required'" name="nouveau mot de passe" v-model="newPassword1">
					</div>
					<div v-if="errors.has('nouveau mot de passe')" class="error-message">{{ errors.first('nouveau mot de passe') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('confirmation du nouveau mot de passe')}">
						<label for="newPassword2">confirmation du nouveau mot de passe</label>
						<input type="password" v-validate="'required'" name="confirmation du nouveau mot de passe" v-model="newPassword2">
					</div>
					<div v-if="errors.has('confirmation du nouveau mot de passe')" class="error-message">{{ errors.first('confirmation du nouveau mot de passe') }}</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="confirm">Enregistrer</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ChangePassword',
	data () {
		return {
			password: null,
			newPassword1: null,
			newPassword2: null
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		confirm () {
			this.$validator.validate().then((validation) => {
				if (validation && (this.newPassword1 === this.newPassword2)) {
					const data = new FormData()
					data.append('current_password', this.password)
					data.append('plain_password[first]', this.newPassword1)
					data.append('plain_password[second]', this.newPassword2)
					this.$store.dispatch('editPassword', data).then((result) => {
						this.$notify({
							type: 'success',
							group: 'default',
							title: 'Votre mot de passe a été changé',
							text: ''
						})
						this.$emit('close')
					}).catch((error) => {
						console.log(error)
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Le changement de mot de passe a échoué',
							text: 'Vous vous êtes peut être trompé dans le mot de passe'
						})
					})
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.default-form-ui {
		.ctn-input {
			input {
				width: 490px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?1a9f173f